import i18n from 'modules/core/lib/i18n'

export default function validateNumberInput(value: string, nullAllowed = false, errorMsg?: string) {
  if (isNumber(value) || (nullAllowed && value === '')) {
    return null
  }

  return nullAllowed ? ' ' : (errorMsg ?? i18n.t('errors.validate_number'))
}

export const isNumber = (value: string) => {
  return !!(value.match(/^[0-9]+$/) || value.match(/^\d+([.,]{1}\d{1,2})?$/))
}
